<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
        <dashboard-grid />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardGrid from "./pages/Dashboard/DashboardGrid";
import DashboardChart1DummyDataRetriever from "../api/DummyData/DashboardChart1DummyDataRetriever";
import DashboardChart2DummyDataRetriever from "../api/DummyData/DashboardChart2DummyDataRetriever";

export default {
  name: "Dashboard",
  components: {
    DashboardGrid,
  },
  data() {
    return {
      chartData1Url: DashboardChart1DummyDataRetriever,
      chart1Colors: ['#f9db2b', '#FF8307', '#626262', '#1A1A1A'],
      chart1Title: this.$t('RecentUploads'),
      chartData2Url: DashboardChart2DummyDataRetriever,
      chart2Colors: ['#f9db2b', '#FF8307', '#626262', '#1A1A1A'],
      chart2Title: this.$t('RecentDownloads'),

    }
  }
}
</script>

<style scoped>

</style>
